import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import AdjustmentInvoice from 'src/app/model/invoice/adjustment-invoice';
import { Adjustment } from 'src/app/model/project/adjustment';
import { Project } from 'src/app/model/project/project';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';

@Component({
  selector: 'ip-board-adjustment-invoicing',
  templateUrl: './ip-board-adjustment-invoicing.component.html',
  styleUrls: ['./ip-board-adjustment-invoicing.component.scss'],
})
export class IPBoardAdjustmentInvoicingComponent implements OnInit {
  @Input()
  adjustment: Adjustment;
  @Input()
  project: Project;
  @Input()
  showTitle: boolean = true;
  @Input()
  showSave = false;
  @Input()
  savingLines = false;
  @Output()
  save = new EventEmitter<any>();
  @Output()
  saveLines = new EventEmitter();

  @Output()
  divergentPricesChecked = new EventEmitter();

  divergentPricesOnly: boolean = false;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {}

  ngOnInit(): void {
    this.divergentPricesOnly =
      CollectionHelper.isPopulated(this.adjustment.projectInvoices) &&
      this.adjustment.projectInvoices.some((pi) => pi.onlyChargePriceLines);
    this.initializeInvoicesForCompaniesWithoutInvoice();
  }

  private initializeInvoicesForCompaniesWithoutInvoice(): void {
    const projectCompanies = this.project.projectContacts.map(
      (pc) => pc.company
    );
    let companyIds = new Set();
    if (this.adjustment.projectInvoices == null) {
      this.adjustment.projectInvoices = [];
    }
    for (let projectInvoice of this.adjustment.projectInvoices) {
      companyIds.add(projectInvoice.company.id);
    }
    let invoiceAdded = false;
    for (let company of projectCompanies) {
      if (!companyIds.has(company.id)) {
        let projectInvoice = new AdjustmentInvoice(company);
        projectInvoice.priceLines = [];
        this.adjustment.projectInvoices.push(projectInvoice);
        invoiceAdded = true;
        companyIds.add(company.id);
      }
    }
    if (invoiceAdded) {
      this.save.emit();
    }
  }

  divergentPricesOnlyChanged(): void {
    if (CollectionHelper.isPopulated(this.adjustment.projectInvoices)) {
      this.adjustment.projectInvoices.forEach(
        (pi) => (pi.onlyChargePriceLines = this.divergentPricesOnly)
      );
      this.projectDisplayObservableService
        .getProjectInvoicePriceChangedSubscribable()
        .next();
    }
    this.divergentPricesChecked.emit(this.divergentPricesOnly);
    this.save.emit();
  }
}
